import fetchSnippetsByIds from './fetch_snippets_by_ids';

export default class RequestFavoriteAnswers {
  constructor(context) {
    this.context = context;
  }

  run() {
    const agentPreferences = this.context.stores.agentPreferences.get();
    const ids = agentPreferences.favoriteAnswerIds;
    if (!ids.length) {
      return;
    }

    fetchSnippetsByIds(this.context, ids).then(snippets => {
      this.context.stores.favoriteAnswers.set(snippets);
    });
  }
}
